define([
	'backbone',
	'humps'
	], function (Backbone, humps) {
		return Backbone.Model.extend({
			url: function() {
				var url = Backbone.Model.prototype.url.apply(this, arguments);
				if(!this.isNew()) {
					return url + '/';
				}

				return url;
			},

			toJSON: function() {
				var json = Backbone.Model.prototype.toJSON.apply(this, arguments);
				json = JSON.parse(JSON.stringify(json));
				json = humps.decamelizeKeys(json, {separator: '_'});
				return json;
			},

			parse: function(response, options) {
				return humps.camelizeKeys(response);
			}

		});
});
